import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["calendar"]

  static values = {
    start: String,
    end: String
  }

  connect() {
    this.syncCalendarFromFields()
  }

  syncCalendarSelection(event) {
    const [startDate, endDate] = this.parseRange(event.target.value)

    if (startDate && endDate) {
      const url = new URL(window.location.href)

      url.searchParams.delete("q[due_at_eq]")
      url.searchParams.delete("q[due_at_gteq]")
      url.searchParams.delete("q[due_at_lteq]")
      url.searchParams.delete("page")
      url.searchParams.set("q[due_at_gteq]", startDate)
      url.searchParams.set("q[due_at_lteq]", endDate)

      Turbo.visit(url.toString(), { action: "advance" })
    }
  }

  syncCalendarFromFields() {
    const startDate = this.startValue.trim()
    const endDate = this.endValue.trim()

    this.calendarTarget.value = startDate || endDate ? `${startDate}/${endDate}` : ""
  }

  parseRange(value) {
    const [startDate = "", endDate = ""] = (value || "").split("/")

    return [startDate, endDate]
  }
}
